<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar v-model="formData" @search="handleSearch"></search-bar>
      </el-header>
      <el-main  ref="main">
        <div style="margin-bottom: 5px;">
          <el-button type="primary" size="small" @click="showExport">上传</el-button>
          <el-button type="primary" size="small" @click="downLoadTemplate">下载模板</el-button>
        </div>
        <el-table
          border
          :header-cell-style="{backgroundColor: '#F4F8FB'}"
          :data="tableData"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
        >

          <el-table-column label="文件名" prop="fileName" show-overflow-tooltip></el-table-column>
          <el-table-column label="更新说明" prop="updateInstructions" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作人" prop="operator" show-overflow-tooltip  width="130px"></el-table-column>
          <el-table-column label="状态" prop="status" show-overflow-tooltip width="180px"></el-table-column>
          <el-table-column label="上传时间" prop="uploadTime" show-overflow-tooltip width="150px"></el-table-column>
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
                <el-button type="text" @click="downLoadRequest(scope.row.filePath, scope.row.fileName)">下载</el-button>
              </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="handleDialogClose">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="small">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="SPU名称" prop="spuName">
                <!--                <el-input v-model="requestParam.spuName" readonly />-->
                <el-select
                  class="word"
                  v-model="requestParam.spuName"
                  filterable
                  remote
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板类型" prop="excuseType">
                <el-select class="word" v-model="requestParam.excuseType">
                  <el-option label="板式" value="1"></el-option>
                  <el-option label="沙发软床" value="2"></el-option>
                  <el-option label="床垫" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="更新说明" prop="updateInstructions" class="word">
                <el-input v-model="requestParam.updateInstructions" />
              </el-form-item>
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button style="margin-left: 10px;"
                             v-loading.fullscreen.lock="fjLoading"
                             element-loading-text="数据导入中"
                             element-loading-spinner="el-icon-loading"
                             element-loading-background="rgba(0, 0, 0, 0.8)"
                             size="small" type="success" @click="checkFormValid">上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
    
    <!-- 模板下载 -->
    <downLoad-template v-model="downLoadTemplateVisible" v-if="downLoadTemplateVisible"></downLoad-template>
  </div>
</template>
<script>
  import axios from '@/utils/axiosInstance';
  import searchBar from './search';
  import {getToken} from '@/utils/auth'
  import downLoadTemplate from './download'
  import pagePathMixin from '@/utils/page-path-mixin'
  export default {
    components:{
      searchBar,
      downLoadTemplate
    },
    mixins: [pagePathMixin],
    data(){
      return {
        requesting:false,
        headers: {
          'Authorization': getToken()
        },
        fileList:[],
        dialogFormVisible:false,
        options:[],
        titleName:'',
        requestParam:{excuseType:'1', updateInstructions: '新增'},
        tableData:[],
        formData:{},
        rules: {},
        fjLoading: false,
        loading:false,
        tableHeight:0,
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        },
        downLoadTemplateVisible: false,
      }
    },
    mounted(){
      this.tableHeight = this.$refs['wrapper'].offsetHeight-125;
      this.init()
    },
    methods:{
      remoteMethod(query){
        if (query !== '') {
          this.loading = true;
          setTimeout(async () => {
            this.loading = false;
            let res = await this.$q.newProduct.filterRate({params:{
                nameOrCode:query
              }})
            console.log(res)
            if(res.success){
              this.options = res.data.map(item=>{
                return {
                  label:item.spuName,
                  value:item.spuId
                }
              })
            }else{
              this.$message.error(res.message)
            }
          }, 200);
        } else {
          this.options = [];
        }
      },
      cancel() {
        this.dialogFormVisible = false;
      },
      handleDialogClose() {
        this.requestParam = { excuseType:'板式' };
        this.fileList = [];
      },
      handleRemove(file, fileList) {
        this.fileList = [];
        console.log(file, fileList);
      },
      httpRequest(file) {

      },
      handleSuccess(res, file) {
        if (res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.cancel();
        this.handleSearch();
      },
      // 验证
      beforeUpload(file) {
        // .xls,.xlsx,.xls.ttt,.xlsx.ttt
        let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
          this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
          return false;
        }
        this.fileList = [];
        this.fileList.push(file);
      },
      checkFormValid(file) {
/*        this.$refs['requestParam'].validate(valid=>{
          if(valid) {
            this.submitUpload(file);
          }else{
            this.$message.error('参数校验失败！')
          }
        })*/
        this.submitUpload(file)
      },
      submitUpload(file) {
        if(this.requesting){
          return;
        }
        if (!this.fileList || this.fileList.length === 0) {
          this.$message.error('请先上传Excel附件');
          return;
        }
        this.requesting = true
        this.fjLoading = true;

        let taskDTO=null;

        taskDTO = {
          spuId:this.requestParam.spuName,
          fileType: 3, //文件类型（1bom表，2信息表，3说辞表）
          updateInstructions:this.requestParam.updateInstructions,
          excuseType:this.requestParam.excuseType==='板式'?1:this.requestParam.excuseType
        };

        this.$q.newProduct.informationUpload({
          data: {
            file: this.fileList[0],
            paramJson: JSON.stringify(taskDTO)
          }
        }, true).then((res) => {
          if (res.success) {
            this.dialogFormVisible=false
            //this.nextUpload(res.data.fileId, this.requestParam.excuseType);
            this.dialogVisible = false;
            this.paginationOpt.pageNum = 1
            this.init()
          } else {
            this.$message.error(res.message);
          }
        }).finally(()=>{
          this.requesting = false;
          this.fjLoading = false;
          this.fileList = []
          this.$refs.upload.clearFiles()
        });
        // this.$refs.upload.submit();
      },
      showExport() {
        this.fileList = [];
        this.dialogFormVisible = true;
        let filename = this.$route.query.fileName;
        filename = filename.substring(0, filename.lastIndexOf('.'))
        this.titleName = filename + '维护';
      },
      downLoad(path, name) {
        let url = path;
        let fileName = name;
        var xhr = new XMLHttpRequest();
        xhr.open("GET",url, true);
        xhr.responseType = "blob";
        xhr.onload = function() {
          if (xhr.status === 200) {
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(xhr.response, fileName);
            } else {
              var link = document.createElement("a");
              var body = document.querySelector("body");

              link.href = window.URL.createObjectURL(xhr.response);
              link.download = fileName;

              // fix Firefox
              link.style.display = "none";
              body.appendChild(link);

              link.click();
              body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
            }
          }
        };
        xhr.send();
      },
      blobDownload(res,fileName) {
        let objectUrl = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click()
        a.remove();
      },
      downLoadRequest(filePath, fileName) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(_=>{
          this.downLoad(filePath, fileName)
          loading.close();
        },300)
        // this.$q.newProduct.downLoadExcuseExcel({
        //   data: {
        //     fileId: fileId,
        //     spuId: spuId
        //   },
        //   options: {
        //     responseType: 'blob'
        //   }
        // })
        //   .then(res=>{
        //     this.blobDownload(res, fileName)
        //   })
      },
      handleSearch(data){
        this.formData = data
        this.paginationOpt.pageNum = 1
        this.init()
      },
      init() {
        this.loading = true;
        let data = {
          filterData: {
            ...this.formData,
            fileType: 3
          },
          pageNum: this.paginationOpt.pageNum,
          pageSize: this.paginationOpt.pageSize
        };
        this.$q.newProduct.queryUploadHistory({data})
          .then(res=>{
            if(res.code == 200) {
              this.tableData = res.data.records;
              this.paginationOpt.total = res.data.total;
            }else{
              this.tableData = [];
            }
          })
          .finally(_=>{
            this.loading = false;
          })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      },
      /**
       * 下载模板
       */
      // 获取导入模板
      downLoadTemplate() {
        this.downLoadTemplateVisible = true;
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .container
    margin 5px
    width auto
    height calc(100% - 10px)
    box-sizing border-box
    border-radius 5px
  >>> .el-header
    background #ffffff
    padding 0 8px
    margin-bottom 5px !important
    position relative
    border-radius 5px
  >>> .el-main
    padding 5px 8px
    background #ffffff
    border-radius 5px

  >>> .el-tabs__header
    margin-bottom 0

  >>> .word .el-input__inner
    width 300px
  >>> .word .el-input.el-input--small.el-input--suffix
    width 300px
</style>


